import React, { useMemo, useState } from "react"
import TableContainer from "../../components/Common/DataTableContainer"
import { Button } from "reactstrap"
import { data } from "pages/AllCharts/chartjs/linechart"
import Swal from "sweetalert2"
import { toast } from "react-toastify"
import axios from "axios"
import moment from "moment"
import SelectLitres from "pages/Fuel-Reward/selectLitres"

const FuelRewardTable = driver => {
  const distance =
    driver?.driver?.data?.total_kms_since_last_reward + " Km" ?? "--"
  const fuel = driver?.driver?.data?.total_fuel_since_last_reward + " L" ?? "--"
  const last_trip = driver?.driver?.data?.last_trip?.created_at
    ? moment(driver?.last_trip?.created_at).format("DD/MM/YY, hh:mm A")
    : "--"
  const [showSelectLitres, setShowSelectLitres] = useState(false)

  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Distance",
        accessorKey: "distance",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Diesel",
        accessorKey: "diesel",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Notes",
        accessorKey: "notes",
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  )

  const handleReset = async () => {
    if (driver?.driver?.data?.total_fuel_since_last_reward < 1) {
      return toast.error("Insufficient amount to reset")
    }
    Swal.fire({
      title: "Are you sure you want to reset?",
      text: "This driver’s counters are normally reset automatically after each diesel claim. Use manual reset only in case of a system or data error.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1DB954",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, reset it!",
    }).then(async result => {
      if (result.isConfirmed) {
        setShowSelectLitres(true)
      }
    })
  }

  const transformedData =
    driver?.driver?.data?.fuel_rewards?.map(reward => ({
      date: reward?.rewarded_at
        ? moment(reward.rewarded_at).format("DD/MM/YY, hh:mm A")
        : "N/A",
      distance: reward?.distance_in_km + " km" ?? "N/A",
      diesel: reward?.reward_in_liters + " L" ?? "N/A",
      notes: reward?.notes || "N/A",
    })) || []

  return (
    <div>
      <div className="d-flex justify-content-end">
        <Button onClick={() => handleReset()} color="success">
          Reset
        </Button>
      </div>
      <div className="card p-4">
        <div className="row mb-4">
          <div className="col">
            <div>
              Distance Traveled <br />
              (since last reset)
            </div>
            <div className="fw-semibold fs-5">{distance}</div>
          </div>
          <div className="col">
            <div>Diesel Rewarded</div>
            <div className="fw-semibold fs-5">{fuel}</div>
          </div>
          <div className="col">
            <div>Last trip</div>
            <div className="fw-semibold bold fs-5">{last_trip}</div>
          </div>
        </div>
        <h6 className="mb-3">Recent Rewards</h6>
        <TableContainer
          columns={columns}
          data={transformedData}
          isGlobalFilter={false}
          isPagination={false}
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
      {showSelectLitres && (
        <SelectLitres
          onClose={() => setShowSelectLitres(false)}
          driverData={driver?.driver?.data}
        />
      )}
    </div>
  )
}

export default FuelRewardTable
